import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Creates an Angular Reactive form validator function which verifies that the password and confirm password fields match.
 * @remarks You should set the validator at FormGroup-level.
 * @param passwordField Key of the password field
 * @param confirmField Key of the password confirmation field
 */
export const createPasswordsMatchValidator = (passwordField: string, confirmField: string): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const passwordControl = control.get(passwordField);
    const confirmControl = control.get(confirmField);

    if (passwordControl?.value !== confirmControl?.value) {
      return { passwordNoMatch: true };
    }

    return null;
  };
};
